/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportType } from './ImportType';
import {
    ImportTypeFromJSON,
    ImportTypeFromJSONTyped,
    ImportTypeToJSON,
    ImportTypeToJSONTyped,
} from './ImportType';

/**
 * 
 * @export
 * @interface StartImportSessionRequestDto
 */
export interface StartImportSessionRequestDto {
    /**
     * 
     * @type {ImportType}
     * @memberof StartImportSessionRequestDto
     */
    importType: ImportType;
    /**
     * 
     * @type {string}
     * @memberof StartImportSessionRequestDto
     */
    importGroupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StartImportSessionRequestDto
     */
    description?: string | null;
}



/**
 * Check if a given object implements the StartImportSessionRequestDto interface.
 */
export function instanceOfStartImportSessionRequestDto(value: object): value is StartImportSessionRequestDto {
    if (!('importType' in value) || value['importType'] === undefined) return false;
    return true;
}

export function StartImportSessionRequestDtoFromJSON(json: any): StartImportSessionRequestDto {
    return StartImportSessionRequestDtoFromJSONTyped(json, false);
}

export function StartImportSessionRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartImportSessionRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'importType': ImportTypeFromJSON(json['importType']),
        'importGroupId': json['importGroupId'] == null ? undefined : json['importGroupId'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function StartImportSessionRequestDtoToJSON(json: any): StartImportSessionRequestDto {
    return StartImportSessionRequestDtoToJSONTyped(json, false);
}

export function StartImportSessionRequestDtoToJSONTyped(value?: StartImportSessionRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'importType': ImportTypeToJSON(value['importType']),
        'importGroupId': value['importGroupId'],
        'description': value['description'],
    };
}

